// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1QXfO","search":"Settings_search__t3gi8","filter":"Settings_filter__pPgrQ"};